<template>
  <div class="main">
    <video hidden autoplay loop>
      <source src="@/assets/audio.mp4" type="video/mp4">
    </video>

    <div v-if="game" class="wrap-particles">
      <div class="main-content">
        <b-navbar v-if="game.state != 'playing'" style="background-color: #fff;">
          <b-navbar-brand>
            <img src="@/assets/logo.png" style="height:40px;">
          </b-navbar-brand>

          <b-navbar-nav class="ml-auto">
            <b-button v-if="game.state == 'waiting'" @click="start"
              class="mt-auto rounded-0 btn btn-dark text-uppercase">Start</b-button>

            <b-button v-if="game.state == 'end'" @click="create"
              class="mt-auto rounded-0 btn btn-dark text-uppercase">Play Again</b-button>
          </b-navbar-nav>
        </b-navbar>

        <b-navbar v-else style="background-color: #000;">
          <b-navbar-brand>
            <img src="@/assets/logo-white.png" style="height:40px;">
          </b-navbar-brand>

          <b-navbar-nav class="ml-auto text-white">
            <b-button v-if="game.state == 'waiting'" @click="start"
              class="mt-auto rounded-0 btn btn-dark text-uppercase">Start</b-button>

            <div v-if="game.startTime">
              <vac ref="vac" :end-time="new Date(game.startTime).getTime() + 60000">
                <span class="h1" slot="process" slot-scope="{ timeObj }">
                  {{ timeObj.s }}
                </span>
                <span class="h1" slot="finish">Time's Up!</span>
              </vac>
            </div>
          </b-navbar-nav>
        </b-navbar>

        <!-- Waiting State -->
        <div v-if="game.state == 'waiting'" class="container py-4 text-center text-white h-75">
          <h1 class="display-4 text-uppercase mono">PIN {{ pin }}</h1>
          <div class="row">
            <div class="col-8">
              <div class="row mt-4">
                <div v-for="player in game.players" :key="player.uid" class="col-sm-6 col-lg-3 py-3 px-4 overflow-hidden">
                  <div :class="[player.team, 'box', 'border', 'rounded', 'px-3', 'py-2']">
                    <span class="h4 mono">{{ player.name }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-4 p-5">
              <div class="card text-dark p-1">
                <img src="@/assets/line.svg" width="100%" alt="">
                <span class="pb-2">Scan this QR code to join game</span>
              </div>
            </div>
          </div>
          
        </div>
        <!-- End Waiting State -->

        <!-- Playing State -->
        <div v-if="game.state == 'playing'" class="text-white h-100 w-100">
          <!-- Exploration Mode -->
          <div v-if="game.mode == 'exploration'">

          </div>
          <!-- End Exploration Mode -->

          <!-- Mining Mode -->
          <div v-if="game.mode == 'mining'" class="mining row h-100 w-100 p-0 m-0">
            <div v-for="team in game.teams" :key="team.name" :class="[`m-${team.name}`, 'col', 'p-4', 'text-center']">
              <img :src="require(`@/assets/team/${team.name}.svg`)" class="w-50">
              <p class="mono display-1 mt-5 text-dark">{{ intToString(scores[team.name]) }}</p>
            </div>
          </div>
          <!-- End Mining Mode -->
        </div>
        <!-- End Playing State -->

        <!-- End State -->
        <div v-if="game.state == 'end'" class="container py-4 h-75">
          <h1 class="text-white text-center">Leaderboard</h1>
          <div class="mx-auto w-sm-100 w-md-75 w-lg-50 p-2 text-white">
            <div v-for="(team, rank) in leaderBoard" :key="team.key"
              :class="[team[0], 'box', 'border', 'rounded', 'p-1', 'my-4']">
              <b-navbar>
                <b-navbar-brand>
                  <span class="chakra-petch h4 text-white mr-3 text-uppercase">{{ rank+1 }}</span>
                  <img :src="require(`@/assets/team/${team[0]}.svg`)" style="height:40px;">
                  <span class="text-white ml-1 text-uppercase">{{ team[0] }}</span>
                </b-navbar-brand>

                <div class="ml-auto">
                </div>

                <span class="ml-auto mono h4">
                  {{ intToString(team[1]) }}
                </span>
              </b-navbar>
            </div>
          </div>
        </div>
        <!-- End End State -->

      </div>

      <vue-particles v-if="game.mode != 'mining' || game.sattus != 'playing'" color="#ffffff" :particleOpacity="0.3"
        :particlesNumber="80" shapeType="circle" :particleSize="5" :lineLinked="false" :moveSpeed="1"
        :hoverEffect="false" :clickEffect="false" />
    </div>
  </div>
</template>

<script>
import firebase from 'firebase'

export default {
  name: 'gameControl',
  data() {
    return {
      game: null
    }
  },
  props: ['pin'],
  mounted() {
    let self = this
    let data = firebase.database().ref('games/' + self.pin)
    data.on('value', function (snapshot) {
      let game = snapshot.val()
      if (game) {
        self.game = game
      } else {
        self.$router.replace('/')
      }
    })
  },
  methods: {
    start: function () {
      let self = this
      if (self.game.players) {
        firebase.database().ref('games/' + self.pin).update({
          state: 'playing',
          startTime: new Date(),
          isStart: true
        }).catch(function (err) {
          console.log(err)
        })
      }
    },
    intToString: function (int) {
      const COUNT_ABBRS = [ '', 'k', 'M', 'G', 'T', 'P', 'E', 'Z', 'Y' ]
      const i = 0 === int ? int : Math.floor(Math.log(int) / Math.log(1000))
      let result = parseFloat((int / Math.pow(1000, i)).toFixed(2))
      return result += `${COUNT_ABBRS[i]}`
    },
    create: function () {
      let self = this

      let rnd = Math.floor(100000 + Math.random() * 900000)
      firebase.database().ref('games/' + rnd).once('value').then(function (snapshot) {
        let isPinExist = (snapshot.val())
        if (!isPinExist) {
          firebase.database().ref('games/' + rnd).update({
            state: 'waiting',
            pin: rnd,
            mode: 'mining',
            teams: self.teams
          }).then(function () {
            self.$router.replace('/game/' + rnd)
            self.$router.go()
          }).catch(function (err) {
            console.log(err)
          })
          console.log('create')
        } else {
          self.create()
          console.log('recursive')
        }
      })
    }
  },
  computed: {
    teams() {
      let teamsName = ['andromeda', 'sagittarius', 'hydra', 'triangulum']
      let _teams = {}
      for (let i=0; i<4; i++) {
        _teams[teamsName[i]] = {
          name: teamsName[i]
        }
      }
      return _teams
    },
    scores: function () {
      let self = this
      let scores = {
        andromeda: 0,
        hydra: 0,
        sagittarius: 0,
        triangulum: 0
      }
      for (let player in self.game.players) {
        scores[self.game.players[player].team] += self.game.players[player].score
      }

      if (this.$refs.vac) {
        console.log(this.$refs.vac.state)
        if (this.$refs.vac.state == 'finised') {
          // eslint-disable-next-line
          firebase.database().ref('games/' + self.pin).update({
            state: 'end',
            scores: scores
          }).catch(function (err) {
            console.log(err)
          })
        }
      }

      return scores
    },
    leaderBoard: function () {
      let self = this
      let leaderBoard = []
      for (let team in self.game.teams) {
        leaderBoard.push([team, self.scores[team]])
      }

      leaderBoard.sort(function (a, b) {
        return a[1] - b[1]
      })

      leaderBoard.reverse()

      return leaderBoard
    }
  }
}
</script>

<style scoped>
.main {
  width: 100vw;
  min-height: 100vh;
  /* overflow: hidden; */
  background-color: #000;
}

.nirvana, .triangulum {
  border-color: #2196f3 !important;
  background-color: #fff1;
}
.valkyrie, .hydra {
  border-color: #f44336 !important;
  background-color: #fff1;
}
.andromeda {
  border-color: #4caf50 !important;
  background-color: #fff1;
}
.sagittarius {
  border-color: #ffeb3b !important;
  background-color: #fff1;
}


.mining {
  background-image: url('../assets/bg-mining.jpg');
  background-size: cover;
  background-position: center;
}
.m-triangulum {
  background-color: #2196f399;
}
.m-hydra {
  background-color: #f4433699;
}
.m-andromeda {
  background-color: #4caf5099;
}
.m-sagittarius {
  background-color: #ffeb3b99;
}
</style>

